import React from 'react';
import { Article } from "@randajan/jet-react/dom/article";
import { DateTime } from '../../../elements/DateTime/DateTime';

import "./Doc.scss";


export const Doc = (props)=>{
    const { name, content, createdAt, updatedAt } = props;
    
    return (
        <div className="Doc slab">
            <main>
                <Article level={0} src={content}/>
            </main>
            <div className="releaseDate">
                Platné ke dni <DateTime className="releaseDate" value={updatedAt}/>
            </div>
        </div>
    )
}

